(function () {
  function initAgeVerification() {
    document.addEventListener('change', function (e) {
      if (e.target.matches('.age-verification-checkbox')) {
        var form = e.target.closest('form');
        if (!form) return;
        var submitBtn = form.querySelector('[type="submit"]');
        if (!submitBtn) return;
        submitBtn.disabled = !e.target.checked;
      }
    });

    // Disable submit buttons on page load if checkbox is present but unchecked
    document.querySelectorAll('.age-verification-checkbox').forEach(function (checkbox) {
      var form = checkbox.closest('form');
      if (!form) return;
      var submitBtn = form.querySelector('[type="submit"]');
      if (!submitBtn) return;
      submitBtn.disabled = !checkbox.checked;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAgeVerification);
  } else {
    initAgeVerification();
  }
})();
